<script lang="ts">
  import { createEventDispatcher } from 'svelte'

  import throttle from '../lib/utils/throttle'

  export let searchText: string

  const dispatch = createEventDispatcher()

  const onInput = throttle(() => {
    dispatch('search', searchText.trim())
  }, 300)
</script>

<div class="search-container">
  <input id="search" bind:value={searchText} type="text" placeholder="Найти проект" on:input={onInput} />
  <label for="search" class="search-icon"></label>
</div>

<style>
  input {
    width: 100%;
    padding: 12px 32px 12px 12px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 16px;
    color: #212121;
    background-color: #ececec;
    box-sizing: border-box;
  }

  input::placeholder {
    font-family: Montserrat, sans-serif;
    color: transparent;
    text-align: right;
    opacity: .35;
  }

  .search-container {
    flex: 1;
    max-width: 200px;
    position: relative;
  }

  .search-icon {
    content: '';
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    right: 0;
    background-image: url('/svg/search.svg');
    background-repeat: no-repeat;
    transform: translateY(-50%);
  }

  @media screen and (min-width: 32rem) {
    input::placeholder {
      color: #212121;
    }

    .search-container {
      /*flex: 1;*/
    }
  }
</style>
